import { Detail, DetailProps, Form, FormProps } from './components'
import { Dialog, DialogPanel } from '@headlessui/react'
import { AtButton, Cancel, Holiday } from '../../atoms'
import { AtButtonDimensions, AtButtonTypes } from '../../types'
import { useState } from 'react'
import { outline } from '../or-bottom-sheet'
import { MlSnackbar, MlSnackbarProps } from '../../molecules'

export * from './components/form'
export * from './default-states'
export * from './configurations'
export * from './components/time-select'
export * from './utils'

export interface OrBookingPanelProps extends FormProps {
  details: DetailProps
  notification?: Omit<MlSnackbarProps, 'className'>
  errorMessage?: string
  holidays?: Holiday
  isInquiryOnly?: boolean
}

export const OrBookingPanel = ({ details, notification, ...props }: OrBookingPanelProps) => {
  const [open, setOpen] = useState(false)
  const panel = (
    <div className="lg:w-[24.75rem] bg-neutrals-white lg:rounded-4 lg:shadow-level-2">
      <Detail {...details} />
      {props.errorMessage && <p className="text-feedback-negative-300 px-5 md:px-10 pt-8">{props.errorMessage}</p>}
      <Form {...props} />
    </div>
  )

  return (
    <>
      <div id="booking-panel" className="hidden lg:block lg:min-h-[27.9375rem]">
        {!open && panel}
      </div>
      {notification && <MlSnackbar className={open ? 'hidden' : 'z-50'} {...notification} />}
      {!open && (
        <div className="fixed z-10 w-full left-0 bottom-0 p-4 bg-neutrals-white lg:hidden">
          <AtButton
            type={AtButtonTypes.PRIMARY}
            size={AtButtonDimensions.LARGE}
            title={props.isInquiryOnly ? 'Inquire Now' : 'Book Now'}
            className="w-full"
            onClick={() => setOpen(true)}
            parentName="OrBookingPanel"
          />
        </div>
      )}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        className="fixed top-0 z-50 lg:hidden h-[100dvh] w-screen overflow-y-auto bg-neutrals-white"
      >
        <DialogPanel>
          <div className="pt-6 p-4 flex flex-row-reverse">
            <button aria-label="Close booking panel" className={outline} onClick={() => setOpen(false)}>
              <Cancel className="w-10 h-10 p-2" />
            </button>
          </div>
          {panel}
          {notification && <MlSnackbar className="z-[2]" {...notification} />}
        </DialogPanel>
      </Dialog>
    </>
  )
}
